export const queryKeys = {
  chats: {
    root: () => ["chats"] as const,
    byStatus: (status: string) => ["chats", { status }] as const,
    messages: (chatId: string) => ["chats", chatId, "messages"] as const,
    detail: (chatId: string) => ["chats", chatId, "detail"] as const,
  },
  bookings: {
    root: () => ["bookings"] as const,
    detail: (bookingId: string) => ["bookings", bookingId, "detail"] as const,
    byUser: (userId: string) => ["bookings", "user", userId] as const,
    upcoming: () => ["bookings", "upcoming"] as const,
    customers: (key: string) => ["bookings", "customers", key] as const,
  },
  payments: {
    root: () => ["payments"] as const,
    detail: (paymentId: string) => ["payments", paymentId, "detail"] as const,
    byBooking: (bookingId: string) => ["payments", bookingId] as const,
  },
  locations: {
    root: () => ["locations"] as const,
    detail: (locationId: string) => ["locations", locationId, "detail"] as const,
  },
  robots: {
    root: () => ["robots"] as const,
    detail: (robotId: string) => ["robots", robotId, "detail"] as const,
    realtime: (robotId: string) => ["robots", robotId, "realtime"] as const,
  },
  notifications: {
    root: () => ["notifications"] as const,
    byType: (type: string) => ["notifications", type] as const,
  },
  users: {
    root: () => ["users"] as const,
    byId: (userId: string) => ["users", userId] as const,
    summary: (userId: string) => ["users", userId, "summary"] as const,
  },
  settings: {
    dreameConfig: () => ['settings', 'dreameCloud'] as const,
  },

  stats: {
    root: () => ["stats"] as const,
    dashboard: () => ["stats", "dashboard"] as const,
  },
};



